export enum EmailAccountMenuTab {
  general = "general",
  settings = "settings",
}
